import { render, staticRenderFns } from "./AdministrarAccesos.vue?vue&type=template&id=4d3c1dfb"
import script from "./AdministrarAccesos.vue?vue&type=script&lang=js"
export * from "./AdministrarAccesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports